export const affiliationModel = {
    desktop_banner: null,
    mobile_banner: null,
    title_affiliate: null,
    select_product: [],
    delete_product: []
}
